import { SampleData } from "../../models/SampleData";
import { IChooseApp } from "../../models/ChooseApp";
import { IFilerInformation } from "../../models/FilerInformation";
import { IPersonalInfo } from "../../models/PersonalInfo";
import { IProjectDetails } from "../../models/ProjectDetails";

export interface ILabSampleModelRequest {
  labPSHPersonalInfoDetails: IPersonalInfo;
  labPSHChooseApplDetails: IChooseApp;
  labPSHSampleTests: SampleData[];
  labPSHPreference: IProjectDetails;
  applicationNumber?: string;
  actionStatus?: string;
  reasonForCancellation?: string;
  labPSHFilerInfoDetails: IFilerInformation;
  labPSHApplicationStatus?: IPSHApplicationStatus;
  submittedFeedback?: number;
  isReportGenerated?: number;
  labReportDetails?: string;
}

export interface IPSHApplicationStatus {
  applicationRequestFor: number;
  miiApplication: number;
  eserviceApplication: number;
  islabapplicationcancelled?: number;
  islabapplicationDuplicated?: number;
  islabapplicationamended?: number;
  amendmentRaisedStage?: number | null;
  actionedStatus?: string;
  ActionRequest: string;
}

export const defAmmendAppStatus: IPSHApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 18,
  eserviceApplication: 14,
  islabapplicationamended: 1,
  ActionRequest: "Amendment request",
};
export const defAppStatus: IPSHApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 2,
  eserviceApplication: 1,
  ActionRequest: "Application Submitted",
};
export const defCancelAppStatus: IPSHApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 25,
  eserviceApplication: 17,
  islabapplicationcancelled: 1,
  ActionRequest: "Cancel request",
};
